import React from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Products from "./views/Products";
import Home from "./views/Home";
import ProductOverview from "./views/ProductOverview";

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-black">
        <Nav />
        <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="products" element={<Products />} />
          <Route path="product" element={<ProductOverview />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
